import React from 'react'
import { Button, Popup, Table, Label, Icon, Divider } from 'semantic-ui-react'
import _ from 'lodash'
import styled from 'styled-components'

import utils from '../../../utils'
import colors from '../../../assets/colors'

const PaymentRow = styled.div`
  font-weight: bold;
  margin-bottom: 6px;
`

const Price = styled.div`
  color: rgba(208, 62, 62, 1);
  margin-left: 3px;
  margin-right: 3px;
  display: ${props => props.inline ? 'inline-block' : 'block'};
`

const Hint = styled.div`
  color: gray;
  display: ${props => props.inline ? 'inline-block' : 'block'};
`

export default class PaymentCell extends React.PureComponent {
  getPaymentSummary = () => {
    const { order } = this.props
    const {
      note,
      voucher,
      sub_total: subTotal,
      delivery_fee: deliveryFee,
      delivery_payer: deliveryPayer,
      total_collect_payment: totalCollectPayment,
    } = order

    const isHasPromoCode = Boolean(voucher)

    const isDiscountVoucher = _.get(voucher, 'voucher.type') === 'DISCOUNT_VOUCHER'
    const promoIcon = isDiscountVoucher ? 'ticket' : 'gift'

    let promoCodeDiscount = 0

    if (isHasPromoCode) {
      const { voucherDiscount } = utils.order.getOrderDiscount({ voucher })

      promoCodeDiscount = voucherDiscount
    }

    const subtotalAfterDiscount = subTotal - promoCodeDiscount

    return {
      promoIcon,
      deliveryFee,
      deliveryPayer,
      isHasPromoCode,
      promoCodeDiscount,
      totalCollectPayment,
      subtotalAfterDiscount,
      hasNote: note.length > 0,
      note: note || 'No delivery note',
      voucherCode: isHasPromoCode ? voucher.voucher.code.toUpperCase() : null
    }
  }

  renderPaymentTrigger = ({ subtotalAfterDiscount, deliveryFee }) => (
    <div>
      <PaymentRow>
        Delivery fee:
        <Price>{` $${deliveryFee}`}</Price>
        <Hint>{` (${utils.order.convertToRiel(deliveryFee)} ៛)`}</Hint>
      </PaymentRow>

      <PaymentRow>
        Customer Total:
        <Price>{` $${subtotalAfterDiscount}`}</Price>
        <Hint>{` (${utils.order.convertToRiel(subtotalAfterDiscount)} ៛)`}</Hint>
      </PaymentRow>
    </div>
  )

  renderPromocode = paymentSummary => {
    const { isHasPromoCode, promoIcon, voucherCode, promoCodeDiscount } = paymentSummary

    if (!isHasPromoCode) return null

    return (
      <div>
        <PaymentRow>
          Promo Code:
          <Label size="small" style={{ marginLeft: 5 }}>
            <Icon name={promoIcon} />
            {voucherCode}
          </Label>
        </PaymentRow>

        <PaymentRow>
          Discount:
          <Price inline>{`$${promoCodeDiscount}`}</Price>
          <Hint inline>{` (${utils.order.convertToRiel(promoCodeDiscount)} ៛)`}</Hint>
        </PaymentRow>

        <Divider style={{ margin: 5 }} />
      </div>
    )
  }

  renderTotalCollectPayment = ({ totalCollectPayment }) => {
    if (totalCollectPayment === 0) return null

    return (
      <PaymentRow>
        Total Collect Payment:
        <Price inline>{` $${totalCollectPayment}`}</Price>
        <Hint inline>{` (${utils.order.convertToRiel(totalCollectPayment)} ៛)`}</Hint>
      </PaymentRow>
    )
  }

  renderDeliveryPayer = ({ deliveryPayer }) => {
    if (!deliveryPayer) return null

    return (
      <PaymentRow>
        Delivery Payer:
        <Label
          style={{
            backgroundColor: colors.yellow,
            color: colors.black,
            marginLeft: 5
          }}
          content={_.capitalize(deliveryPayer)}
        />
      </PaymentRow>
    )
  }

  render() {
    const { showEditNoteModal, readOnly } = this.props
    const paymentSummary = this.getPaymentSummary()

    return (
      <Table.Cell textAlign="center">
        {paymentSummary.isHasPromoCode && (
          <Label color="green" style={{ margin: 0, width: 120, marginBottom: 3 }}>
            Promo Code
          </Label>
        )}
        <Popup trigger={this.renderPaymentTrigger(paymentSummary)} wide position="top center" >
          {this.renderDeliveryPayer(paymentSummary)}
          {this.renderPromocode(paymentSummary)}
          {this.renderTotalCollectPayment(paymentSummary)}
        </Popup>

        <div>
          <Popup
            trigger={
              <Button
                color={paymentSummary.hasNote ? 'green' : undefined}
                content="Note"
                icon="pencil"
                size="mini"
                labelPosition="right"
                style={{ margin: 0, width: 120, marginTop: 5 }}
                onClick={() => !readOnly && showEditNoteModal()}
              />
            }
            wide
            position="top center"
          >
            {paymentSummary.note}
          </Popup>
        </div>
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/express/components/PaymentCell.js